import { InjectionToken } from '@angular/core';
import { createMocks } from '@backbase/foundation-ang/data-http';
export const ARRANGEMENTS_DATA_HTTP_ANG_CONFIG = new InjectionToken(
  'product-summary-data-http-ang Data Service :: HTTP Config',
);
const examples = [
  {
    urlPattern: '/client-api/{version}/arrangements/{id}',
    method: 'GET',
    responses: [
      {
        status: 200,
        body: {
          "additions": {
              "additionalCardExpirationDates": "",
              "additionalCardNumbers": "",
              "creditLineBalAvailable": "79.92",
              "accountStatus": "Cuenta Activa",
              "lastStatementDate": "30-11-2022",
              "lastTransactionDate": "29-07-2022",
              "productTypeName": "-1",
              "monthlyAverageBalance": "79.92",
              "currency": "RD",
              "relationshipManager": "CAPITAL HUMANO",
              "creditLineDays": "0",
              "mainCardNumber": "-1",
              "mainCardExpirationDate": "-1",
              "interestRate": "0.000000",
              "accountOfficialName": "CAPITAL HUMANO",
              "totalBalance": "79.92",
              "retainedBalance": "0.00",
              "regionalCode": "DO20BANS00000000001200046573",
              "additionalCardNames": "",
              "accountStatusCode": "active",
              "mainCardName": "-1",
              "currencyCode": "DOP",
              "lastStmtDate": "30-11-2022",
              "deferredBalance": "0.00",
              "status": "success",
              "accountBranch": "CASA MATRIZ"
          },
          "name": "Ahorro nómina",
          "availableBalance": 79.92,
          "currency": "DOP",
          "bankBranchCode": "CASA MATRIZ",
          "accountOpeningDate": "2016-05-03T04:00:00Z",
          "accountInterestRate": 0,
          "startDate": "2016-05-03T04:00:00Z",
          "bankAlias": "Cuentas de ahorros",
          "displayName": "Ahorro nómina",
          "debitCards": [],
          "id": "1865091c-c448-47e3-aaa6-23e1d7a02dd6",
          "productKindName": "Savings Account",
          "visible": true,
          "legalEntityIds": [
              "8a9ed03b80015be401803e2291fc002b"
          ],
          "productId": "af129448-3c7f-4053-8099-2c809e8ac38c",
          "productTypeName": "Ahorro nómina",
          "product": {
              "externalId": "CA27",
              "typeName": "Ahorro nómina",
              "productKind": {
                  "externalKindId": "kind2",
                  "kindName": "Savings Account",
                  "kindUri": "savings-account"
              }
          }
      }
      },
    ],
  },
];

export const ArrangementsDataHttpMocksProvider = createMocks(examples, ARRANGEMENTS_DATA_HTTP_ANG_CONFIG);
